"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterItemFooter = exports.EMPTY_REASONS = void 0;
var _localization = require("@lt/localization");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _pluralizeUtils = require("../../../../utils/pluralizeUtils");
// Icons
var InstantConfirmIcon = function InstantConfirmIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("linearGradient", {
    id: "instant-confirm_svg__a",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "0%",
    stopColor: "#5BC9F5"
  }), /*#__PURE__*/_react["default"].createElement("stop", {
    offset: "100%",
    stopColor: "#2080F1"
  }))), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "url(#instant-confirm_svg__a) #009df9",
    fillRule: "evenodd",
    d: "M291.237 3071l-9.075 12.238 3.218.19-1.276 8.959 8.898-12.964-2.936-.202z",
    transform: "translate(-282 -3071)"
  }));
};
InstantConfirmIcon.defaultProps = {
  className: "instant-confirm_svg__instant-confirm-icon",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 11 22"
}; // Utils:
var EMPTY_REASONS = exports.EMPTY_REASONS = /*#__PURE__*/function (EMPTY_REASONS) {
  EMPTY_REASONS["INSTANT_CONFIRM"] = "instantConfirm";
  EMPTY_REASONS["DATE"] = "date";
  EMPTY_REASONS["FREE_CANCEL"] = "freeCancel";
  return EMPTY_REASONS;
}({});
var FilterItemFooter = exports.FilterItemFooter = function FilterItemFooter(props) {
  var hasTours = props.hasTours,
    count = props.count,
    emptyReason = props.emptyReason,
    isHotelOnly = props.isHotelOnly;
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  var toursText = "".concat(count, " ").concat(isHotelOnly ? (0, _pluralizeUtils.pluralizeOffers)(count) : (0, _pluralizeUtils.pluralizeTours)(count));
  var chooseReasonText = function chooseReasonText(type) {
    switch (type) {
      case EMPTY_REASONS.INSTANT_CONFIRM:
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledInstantConfrim, null, /*#__PURE__*/_react["default"].createElement(StyledInstantConfrimIcon, null)), /*#__PURE__*/_react["default"].createElement("span", null, t('hotel.filters.footer.instantConfirm')));
      case EMPTY_REASONS.DATE:
        return t('hotel.filters.footer.noTours');
      case EMPTY_REASONS.FREE_CANCEL:
        return t('hotel.filters.footer.freeCancel');
      default:
        return null;
    }
  };
  return /*#__PURE__*/_react["default"].createElement(StyledCheckboxBottom, null, hasTours ? /*#__PURE__*/_react["default"].createElement("span", null, toursText) : /*#__PURE__*/_react["default"].createElement(StyledNoToursText, null, chooseReasonText(emptyReason)));
};
var StyledCheckboxBottom = _styledComponents["default"].div.withConfig({
  displayName: "FilterItemFooter__StyledCheckboxBottom",
  componentId: "sc-1uyz3k2-0"
})(["font-size:12px;color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.greyLight;
});
var StyledNoToursText = _styledComponents["default"].div.withConfig({
  displayName: "FilterItemFooter__StyledNoToursText",
  componentId: "sc-1uyz3k2-1"
})(["color:#c2c5cc;display:flex;align-items:center;"]);
var StyledInstantConfrim = _styledComponents["default"].span.withConfig({
  displayName: "FilterItemFooter__StyledInstantConfrim",
  componentId: "sc-1uyz3k2-2"
})(["margin-right:5px;display:inline-block;vertical-align:top;position:relative;&::after{display:block;content:'';position:absolute;width:12px;height:1px;background-color:#c2c5cc;top:3px;left:0;transform:rotate(45deg);transform-origin:left;}"]);
var StyledInstantConfrimIcon = (0, _styledComponents["default"])(InstantConfirmIcon).withConfig({
  displayName: "FilterItemFooter__StyledInstantConfrimIcon",
  componentId: "sc-1uyz3k2-3"
})(["width:8px;path{fill:none;stroke:#c2c5cc;stroke-width:1px;}"]);